import { render, staticRenderFns } from "./DataRemoveModal.vue?vue&type=template&id=224aef1a"
import script from "./DataRemoveModal.vue?vue&type=script&lang=js"
export * from "./DataRemoveModal.vue?vue&type=script&lang=js"
import style0 from "./DataRemoveModal.vue?vue&type=style&index=0&id=224aef1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports